module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/pause-a9d01f203ee03487ae229581e35bbd02.svg";